<template>
    <div>
        <table class="hts-tables">
            <thead class="thead">
                <tr>
                    <th
                        scope="col"
                        class="col">
                        Loại vật tư
                    </th>
                    <th
                        scope="col"
                        class="col">
                        Mô tả
                    </th>
                    <th
                        scope="col"
                        class="col">
                        <span class="sr">
                            {{ $t('labels.edit') }}
                        </span>
                    </th>
                    <th
                        scope="col"
                        class="col">
                        <span class="sr">
                            {{ $t('labels.delete') }}
                        </span>
                    </th>
                </tr>
            </thead>
            <tbody class="body">
                <tr
                    v-for="typeSupply in props.listTypeSupplies"
                    :key="typeSupply.id">
                    <td class="col">
                        {{ typeSupply.name }}
                    </td>
                    <td class="col">
                        {{ typeSupply.description }}
                    </td>
                    <td class="col right">
                        <hts-form-button
                            type="text"
                            color="info"
                            @click="handleEditTypeSupply(typeSupply)">
                            {{ $t('labels.edit') }}
                        </hts-form-button>
                    </td>
                    <td class="col right">
                        <hts-form-button
                            type="text"
                            color="error"
                            @click="handleDeleteTypeSupply(typeSupply)">
                            {{ $t('labels.delete') }}
                        </hts-form-button>
                    </td>
                </tr>
            </tbody>
        </table>

        <hts-modal
            :show="showPopupDeleteTypeSupply"
            :title="$t('labels.deleteDriver')"
            type="confirm"
            :content="$t('labels.confirmDeleteDriver')"
            @hide="closePopupDeleteTypeVehicle"
            @confirm="actionDeleteTypeVehicle" />
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
  listTypeSupplies: Object
})

const emits = defineEmits(['actionDeleteTypeSupply', 'handleEditTypeSupply'])

const showPopupDeleteTypeSupply = ref(false)
const typeSupplyIsSelectedForDelete = reactive({})

const handleDeleteTypeSupply = (typeSupply: object) => {
  showPopupDeleteTypeSupply.value = true
  Object.assign(typeSupplyIsSelectedForDelete, typeSupply)
}

const closePopupDeleteTypeVehicle = () => {
  showPopupDeleteTypeSupply.value = false
  Object.assign(typeSupplyIsSelectedForDelete, {})
}

const actionDeleteTypeVehicle = () => {
  const typeSupply = typeSupplyIsSelectedForDelete
  emits('actionDeleteTypeSupply', typeSupply)
  closePopupDeleteTypeVehicle()
}

const handleEditTypeSupply = (typeSupply: object) => {
  emits('handleEditTypeSupply', typeSupply)
}
</script>
